import { Avatar, Dropdown, Grid, Space, Typography } from 'antd';
import {
  UserOutlined,
  LogoutOutlined,
  IdcardOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const ROLE_LABELS: Record<string, string> = {
  owner: 'Chủ chi nhánh',
  manager: 'Quản lý',
  cashier: 'Thu ngân',
  inventory: 'Kho',
  viewer: 'Xem',
  b2b_sales: 'Nhân viên kinh doanh B2B',
  b2b_sales_manager: 'Quản lý kinh doanh B2B',
  accountant: 'Kế toán',
};

/**
 * User avatar + dropdown trên Header (EG-355 §4).
 * Items: Hồ sơ (nhân sự HRM), Tài khoản (đăng nhập ERP), Đổi mật khẩu, Đăng xuất.
 *
 * Mobile (<lg): chỉ hiện avatar (ẩn name/role text để tiết kiệm topbar space).
 */
export const HeaderUserMenu = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isMobile = !screens.lg;

  const items = [
    // "Hồ sơ" = hồ sơ NHÂN SỰ (HRM), nơi nhân viên xem thông tin của mình và đề xuất sửa.
    // "Tài khoản" = tài khoản đăng nhập ERP. Trước đây mục "Hồ sơ" trỏ vào tài khoản ERP
    // nên hồ sơ nhân sự không có lối vào nào ngoài gõ thẳng URL.
    // Mọi tài khoản đều có mục này (2026-10-08): xem hồ sơ của chính mình không còn cần quyền.
    {
      key: 'employee-profile',
      icon: <IdcardOutlined />,
      label: 'Hồ sơ',
      onClick: () => navigate(ROUTES.hrm.myProfile),
    },
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Tài khoản',
      onClick: () => navigate(ROUTES.settings.profile),
    },
    {
      key: 'change-password',
      icon: <KeyOutlined />,
      label: 'Đổi mật khẩu',
      onClick: () => navigate(ROUTES.auth.changePassword),
    },
    { type: 'divider' as const },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
      danger: true,
      onClick: () => logout(),
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight" arrow trigger={['click']}>
      <Space size={8} style={{ cursor: 'pointer' }} data-testid="user-menu-trigger">
        <Avatar src={user?.avatar} icon={<UserOutlined />} style={{ backgroundColor: '#a4193d' }} size="small" />
        {!isMobile && (
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
            <Text strong style={{ fontSize: 13 }}>
              {user?.name || 'Nhân viên'}
            </Text>
            <Text type="secondary" style={{ fontSize: 11 }}>
              {ROLE_LABELS[user?.role ?? ''] ?? user?.role}
            </Text>
          </div>
        )}
      </Space>
    </Dropdown>
  );
};
